








































import Component from "vue-class-component";
import axios from "axios";

import { BaseRootPageComponent } from "../BaseRootPageComponent";
import { updateGTMGlobalVariables } from "@/utils/gtm";

export interface CreditsObj {
  [key: string]: CreditObj;
}

export interface CreditObj {
  repository: string;
  url?: string;
  // Indicates that the credits are for a Vyaire package
  private?: boolean;
}

export interface Credit {
  name: string;
  url: string;
}

@Component
export default class Credits extends BaseRootPageComponent {
  credits: Credit[] = [];

  // Collect all non-Microsoft and nuget packages not used for testing
  // Include all dependencies (and sub-dependencies) of referenced packages
  dotNetCredits: Credit[] = [
    { name: "linq2db", url: "http://linq2db.com" },
    { name: "linq2db EntityFrameworkCore", url: "https://github.com/linq2db/linq2db.EntityFrameworkCore" },
    { name: "Npgsql", url: "https://www.npgsql.org" },
    { name: "Npgsql.EntityFrameworkCore.PostgreSQL", url: "http://www.npgsql.org/efcore/index.html" }
  ];

  // We don't currently have any iOS libraries, this is just a place holder for when we do
  iosCredits: Credit[] = [];

  async created() {
    const jsCredits = await this.loadJsCredits();

    // updateGTMGlobalVariables(this);

    this.credits = jsCredits
      .concat(this.dotNetCredits)
      .concat(this.iosCredits)
      .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
  }

  async loadJsCredits() {
    try {
      // If running locally and this file isn't found, make sure to run: npm licenses
      const creditsObj = (await axios.get("/credits/javascript.json")) as CreditsObj;

      return this.parseJsCredits(creditsObj);
    } catch (error) {
      console.error("Failed loading JS credits", error);
      return [];
    }
  }

  parseJsCredits(creditsObj: CreditsObj) {
    const credits: Credit[] = [];

    Object.getOwnPropertyNames(creditsObj).forEach(key => {
      const credit = creditsObj[key];

      // Skip private credits because these belong to Vyaire
      if (credit.private) return;

      // The package name can include "@", so don't use split just find the last "@" to separate the package name from
      // the version
      const lastAt = key.lastIndexOf("@");
      const name = lastAt >= 0 ? key.substring(0, lastAt) : key;

      credits.push({
        name: name,
        // If the URL isn't defined, fall back to the repository
        url: credit.url || credit.repository
      });
    });

    return credits;
  }
}
